import React from "react";
import {
  GraduationCap,
  Folder,
  Folders,
  UserRound,
  Users,
  UsersRound,
} from "lucide-react";
import { TFunction } from "i18next";
import { NavigateFunction } from "react-router-dom";
import { CreateOption } from "@components/CreateOptionPickerCst/types";

export type CreatePickerKind = "catalog" | "users-groups";

export interface CreatePickerBuildContext {
  navigate: NavigateFunction;
  corporateId: string;
  t: TFunction;
}

export interface CreatePickerDefinition {
  permission: string;
  titleKey: string;
  buildOptions: (ctx: CreatePickerBuildContext) => CreateOption[];
}

export const CREATE_PICKER_REGISTRY: Record<
  CreatePickerKind,
  CreatePickerDefinition
> = {
  catalog: {
    permission: "learning_catalogue.learning_object.write",
    titleKey: "catalog.title",
    buildOptions: ({ navigate, corporateId, t }) => [
      {
        key: "activity",
        icon: <GraduationCap size={32} />,
        title: t("catalog.options.activity.title"),
        description: t("catalog.options.activity.description"),
        onSelect: () =>
          navigate(
            `/v2/corporate/${corporateId}/detail/catalog/activities/add`,
          ),
      },
      {
        key: "course",
        icon: <Folder size={32} />,
        title: t("catalog.options.course.title"),
        description: t("catalog.options.course.description"),
        onSelect: () =>
          navigate(`/v2/corporate/${corporateId}/detail/catalog/courses/add`),
      },
      {
        key: "path",
        icon: <Folders size={32} />,
        title: t("catalog.options.path.title"),
        description: t("catalog.options.path.description"),
        onSelect: () =>
          navigate(`/v2/corporate/${corporateId}/detail/catalog/paths/add`),
      },
    ],
  },
  // TODO: i flussi di creazione utente/gruppo verranno collegati al wizard V2.
  // Per ora le opzioni puntano alle pagine Add esistenti.
  "users-groups": {
    permission: "usermgmt.users.add",
    titleKey: "users-groups.title",
    buildOptions: ({ navigate, corporateId, t }) => [
      {
        key: "user",
        icon: <UserRound size={32} />,
        title: t("users-groups.options.user.title"),
        description: t("users-groups.options.user.description"),
        onSelect: () =>
          navigate(`/v2/corporate/${corporateId}/detail/users-groups/add`),
      },
      {
        key: "static-group",
        icon: <Users size={32} />,
        title: t("users-groups.options.staticGroup.title"),
        description: t("users-groups.options.staticGroup.description"),
        onSelect: () =>
          navigate(
            `/v2/corporate/${corporateId}/detail/users-groups/groups/add`,
          ),
      },
      {
        key: "dynamic-group",
        icon: <UsersRound size={32} />,
        title: t("users-groups.options.dynamicGroup.title"),
        description: t("users-groups.options.dynamicGroup.description"),
        onSelect: () =>
          navigate(
            `/v2/corporate/${corporateId}/detail/users-groups/dynamic-groups/add`,
          ),
      },
    ],
  },
};
